module.exports = __webpack_public_path__ + "8ddc047106e57d514d51825e2815c867.svg";